var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{on:{"close":_vm.close}},[_c('div',{staticStyle:{"width":"100%"}},[_c('md-table',{attrs:{"md-card":""}},[_c('md-table-toolbar',[_c('h4',[_vm._v("\n          "+_vm._s(_vm.currentSupplyName)+"\n        ")])]),_vm._v(" "),_c('md-table-row',[_c('md-table-head')],1),_vm._v(" "),_vm._l((_vm.currentOCs),function(oc,i){return _c('md-table-row',{key:i},[_c('md-table-cell',[_vm._v("\n          "+_vm._s(oc)+"\n        ")])],1)})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Reports/InventoryLog/OCDetailsModal.vue